import React, { useEffect } from 'react';
import { CascadingPanel, CascadingPanels, useCascadingPanelsConnector } from '@keplerco/core';
import { FreemiumBulkUploadFocusPanel } from './freemium-bulk-upload-focus-panel';

export enum FreemiumBulkUploadCascadingPanelIds {
  Sections = 'sections',
}

export interface IFreemiumBulkUploadCascadingPanelsProps {
  onCancel: () => void;
}

export function FreemiumBulkUploadCascadingPanels(props: IFreemiumBulkUploadCascadingPanelsProps): JSX.Element {
  const { openPanelIds, close, next } = useCascadingPanelsConnector();

  useEffect(() => {
    next(FreemiumBulkUploadCascadingPanelIds.Sections);
  }, []);

  return (
    <CascadingPanels
      openPanelIds={openPanelIds}
      onClosePanel={id => {
        close(id);
        if (id === FreemiumBulkUploadCascadingPanelIds.Sections || openPanelIds.length <= 1) props.onCancel();
      }}
    >
      <CascadingPanel id={FreemiumBulkUploadCascadingPanelIds.Sections}>
        <FreemiumBulkUploadFocusPanel
          onCancel={() => props.onCancel()}
        />
      </CascadingPanel>
    </CascadingPanels>
  );
}

